import { Box, Flex, Heading, Text, useToast } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../../services/api";
import PrimaryButton from "../../../components/primaryButton/primarybutton";
import GoBack from "../../../components/goBack";
import CustomInput from "../../../components/customInput/customInput";
import CustomSelect from "../../../components/customSelect/customSelect";
import countriesData from '../../../utils/countries.json'
import SpinLoader from "../../../components/spinLoader/spinLoader";

const Signup = () => {
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);

    // Access individual query parameters
    const emailx = queryParams.get('email');
    const role = queryParams.get('role');
    const inviteId = queryParams.get('inviteId');
    const agencyId = queryParams.get('agencyId');


    const clientId = queryParams.get('clientId');
    const firstNamex = queryParams.get('firstName');
    const lastNamex = queryParams.get('lastName');

    const [email, setEmail] = useState(emailx);
    const [firstName, setFirstName] = useState(firstNamex);
    const [lastName, setLastName] = useState(lastNamex);
    const [password, setPassword] = useState("");
    const [cPassword, setCPassword] = useState("");
    const [phone, setPhone] = useState("");
    const [loading, setLoading] = useState(false);
    const [country, setCountry] = useState('')
    const [defaultCountry, setDefaultCountry] = useState('')
    const [state, setState] = useState("");
    const [area, setArea] = useState("");
    const [town, setTown] = useState("");
    const [address, setAddress] = useState("");
    const [interests, setInterests] = useState([]);
    const [interestOptions, setInterestOptions] = useState([]);
    const [loadingz, setLoadingz] = useState()

    const getInterestOptions = async () => {
        setLoadingz(true)
        try {
            const { data } = await axiosInstance.get('/employees/activation-interest-options')
            setInterestOptions(data?.data)
        } catch (error) {
            console.error(error)
        } finally {
            setLoadingz(false)
        }
    }

    useEffect(() => {
        getInterestOptions()
    }, [])

    const countries = countriesData?.map(x => ({
        title: x?.name,
        value: x?.name?.toLowerCase(),
        code: x?.code2,
        states: x?.states
    }))

    const places2 = countries?.find(x => x?.value === (country || "nigeria"))?.states?.map(i => ({
        title: i?.name,
        value: i?.name?.toLowerCase(),
        listValue: i?.subdivision?.map(i => ({
            title: i,
            value: i,
        }))
    })) || []

    const toast = useToast()

    const navigate = useNavigate();

    useEffect(() => {
        // Fetch the user's country using ipinfo.io
        fetch("https://ipinfo.io/json?token=1920c15b6512bf")
            .then((response) => response.json())
            .then((data) => {
                const countryName = data.country; // ISO country code
                // const countryFullName = data.country_name || countryName; // Full country name (depends on the service used)
                console.log(countryName)
                // Format the response
                setDefaultCountry(countryName);
            })
            .catch((error) => console.error("Error fetching location:", error));
    }, []);

    const datax = {
        firstName,
        lastName,
        email: email,
        password: password,
        phoneNumber: phone.charAt(0) === "0"
            ? "+234" + phone.slice(1)
            : "+234" + phone,
        role,
        inviteId,
        country: country || countries?.find(x => x.code === defaultCountry)?.value,
        address,
        state,
        localGovernment: area,
        town,
        activationInterests: interests
    }

    if (clientId) {
        datax.clientId = clientId
    }


    if (agencyId) {
        datax.agencyId = agencyId
    }


    // const datax = clientId ?
    //     {
    //         firstName,
    //         lastName,
    //         email: email,
    //         password: password,
    //         phoneNumber: phone.charAt(0) === "0"
    //             ? "+234" + phone.slice(1)
    //             : "+234" + phone,
    //         role,
    //         inviteId,
    //         clientId,
    //         country: country || countries?.find(x => x.code === defaultCountry)?.value,
    //         address,
    //         state,
    //         localGovernment: area,
    //         town,
    //         agencyId,
    //         activationInterests: interests
    //     }
    //     :
    //     {
    //         firstName,
    //         lastName,
    //         email: email,
    //         password: password,
    //         phoneNumber: phone.charAt(0) === "0"
    //             ? "+234" + phone.slice(1)
    //             : "+234" + phone,
    //         role,
    //         inviteId,
    //         country: country || countries?.find(x => x.code === defaultCountry)?.value,
    //         address,
    //         state,
    //         localGovernment: area,
    //         town,
    //         agencyId,
    //         activationInterests: interests
    //     }


    const signup = async (e) => {
        e.preventDefault();
        if (password === cPassword) {
            setLoading(true)
            try {
                const { data } = await axiosInstance.post("auth/sign-up", datax)
                console.log("test", data)
                navigate("/verify", { state: { email: email } })
                toast({
                    description: data?.message,
                    status: "success",
                    position: "top-right",
                    duration: 5000,
                    isClosable: true,
                });
            } catch (error) {
                console.log(error?.response?.data?.message)
                toast({
                    title: "An Error Occurred",
                    description: error?.response?.data?.message,
                    status: "error",
                    position: "top-right",
                    duration: 5000,
                    isClosable: true,
                });
            } finally {
                setLoading(false)
            }
        } else {
            toast({
                description: "Password Mismatch, Please try again.",
                status: "error",
                position: "top-right",
                duration: 5000,
                isClosable: true,
            });
        }
    }

    const handleSelect = (val) => {
        if (!interests?.includes(val)) {
            setInterests([...interests, val])
        } else {
            const filtered = interests?.filter(i => i !== val)
            setInterests(filtered)
        }
    }


    return (
        <Box>
            <GoBack />
            {loadingz ?
                <SpinLoader />
                :
                <>
                    <Box padding="1rem">
                        <Heading mt={6} fontWeight={500} fontSize="1.3rem" color="#030303" fontFamily='Roboto'>Sign up as a {role?.toLowerCase()}</Heading>
                        <Text mt={2} mb="2rem" color={"#667085"} fontSize={".9rem"}>Enter your details to Sign up</Text>
                        <form onSubmit={signup}>
                            <Flex gap=".8rem">
                                <CustomInput
                                    type={"text"}
                                    required
                                    placeholder={"First Name"}
                                    mb={".8rem"}
                                    value={firstName}
                                    onChange={e => setFirstName(e.target.value)}
                                />
                                <CustomInput
                                    type={"text"}
                                    required
                                    placeholder={"Last Name"}
                                    mb={".8rem"}
                                    value={lastName}
                                    onChange={e => setLastName(e.target.value)}
                                />
                            </Flex>
                            <CustomInput
                                type={"email"}
                                required
                                placeholder={"Email Address"}
                                mb={".8rem"}
                                value={email}
                            />
                            <Flex mb=".8rem" gap={".8rem"}>
                                <CustomSelect
                                    required
                                    options={[{ title: countries?.find(x => x?.code === defaultCountry)?.title, value: countries?.find(x => x?.code === defaultCountry)?.value }, ...countries]}
                                    // placeholder={"Country"}
                                    onChange={e => setCountry(e.target.value)}
                                />
                                <CustomSelect
                                    required
                                    options={places2}
                                    placeholder={"State"}
                                    onChange={e => setState(e.target.value)}
                                />

                            </Flex>

                            <Flex mb=".8rem" gap={".8rem"}>
                                <CustomSelect
                                    required
                                    options={places2?.filter(i => i.value === state)[0]?.listValue}
                                    placeholder={"Area"}
                                    onChange={e => setArea(e.target.value)}
                                />
                                <CustomInput
                                    type={"text"}
                                    required
                                    placeholder={"Town"}
                                    onChange={e => setTown(e.target.value)}
                                />

                            </Flex>
                            <CustomInput
                                type={"text"}
                                required
                                placeholder={"Adress"}
                                mb={".8rem"}
                                onChange={e => setAddress(e.target.value)}
                            />
                            <CustomInput
                                type={"tel"}
                                required
                                placeholder={"Phone Number"}
                                mb={".8rem"}
                                minLength={"11"}
                                maxLength={"11"}
                                onChange={e => setPhone(e.target.value)}
                            />
                            <CustomInput
                                type={"password"}
                                required
                                placeholder={"Password"}
                                onChange={e => setPassword(e.target.value)}
                                mb={".8rem"}
                            />
                            <CustomInput
                                type={"password"}
                                required
                                placeholder={"Confirm Password"}
                                onChange={e => setCPassword(e.target.value)}
                            />
                            <Text mt={".7rem"} opacity={.7} fontSize={".8rem"}>Select One or more activation interests</Text>
                            <Flex gap=".7rem" flexWrap={"wrap"} mt=".8rem">
                                {interestOptions?.map(i => {
                                    return (
                                        <Text cursor={"pointer"} onClick={() => handleSelect(i)} padding={'.45rem'} borderRadius={'12px'} border={interests?.includes(i) ? '2px solid green' : '1px solid lightgray'} fontSize={"12px"} fontWeight={"500"}>{i}</Text>
                                    )
                                })}
                            </Flex>
                            <br /><br /><br />
                            <PrimaryButton type="submit" text="Sign Up" icon="next" func={() => { }} loading={loading} />
                            <Text mt="2rem" textAlign={"center"} fontSize={".9rem"} color="#475467">Already have an account? <span onClick={() => navigate("/login", { state: { userType: role } })} style={{ fontWeight: "600", color: "#7F56D9", cursor: "pointer", transition: "250ms ease" }}>Login here</span></Text>
                        </form>
                    </Box>
                </>}
        </Box>
    )
}

export default Signup;

